import React from 'react';
import { OrbitProgress } from 'react-loading-indicators';
import { theme } from '../utils/theme';


const BusyIndicator = () => {
    return (
        <div className="busy-indicator-overlay">
            <OrbitProgress variant="disc" color={theme.primary} size="large" dense text="" textColor="" />
        </div>
    );
};

export default BusyIndicator;